import * as React from 'react';

export default function Home() {
    return (
        <div>This is the  home page</div>
    );
}

